<template>
  <div class="realtime-monitor-layout">
    <LeftVideoWall :videos="videoWall" :stats="stats" />
    <RealtimeDataStatusPanel :scenes="scenes" :online-count="onlineDeviceCount" />
  </div>
</template>

<script setup>
import LeftVideoWall from "./LeftVideoWall.vue";
import RealtimeDataStatusPanel from "./RealtimeDataStatusPanel.vue";

const leftGreenhouseLiveVideo = "https://open.ys7.com/v3/openlive/FC4283860_1_2.m3u8?expire=1815009817&id=996708471594315776&t=94b7cc3d74e5ba694b9c6fdceb5af78531e67c075e293400f75f0b7655fa76d0&ev=101";
const leftFarmlandLiveVideo = "https://open.ys7.com/v3/openlive/E53817475_1_2.m3u8?expire=1815009972&id=996709122902642688&t=f0fd56e29115fa139b53a07daea9447ed989903294f762dade0ea13623c29e20&ev=101";
const leftCropLiveVideo = "https://open.ys7.com/v3/openlive/AZ8538489_1_1.m3u8?expire=1815010140&id=996709824559345664&t=e459d55d61e1762a385eea0001380a846794d3b41b205b16e3f49a7e1ede08d3&ev=101";
const leftSweetPotatoLiveVideo = "https://open.ys7.com/v3/openlive/FB2502253_1_1.m3u8?expire=1815010678&id=996712081728221184&t=f9e7058e62a99d0026372cdca3dd751b77c0430e7328828305d35be174dd8283&ev=101";
const livestockLiveVideo = "https://open.ys7.com/v3/openlive/FB2502253_1_1.m3u8?expire=1815010678&id=996712081728221184&t=f9e7058e62a99d0026372cdca3dd751b77c0430e7328828305d35be174dd8283&ev=101";  //畜禽养殖场
const greenhouseLiveVideo = "https://open.ys7.com/v3/openlive/FB2502104_1_1.m3u8?expire=1815010481&id=996711258088595456&t=cdf770209a0b0bbe47fa7b4304f3e2c0213c56b2458900d1337df91be181e581&ev=101"; //z智慧温室
const farmlandLiveVideo = "https://open.ys7.com/v3/openlive/D06502219_1_1.m3u8?expire=1815010023&id=996709333964206080&t=d9c27bb4476cdf74c16cb1710c0ed0011949a72011254360b678d5820368cd8c&ev=101";
const leftPosterOne = require("@/assets/img/left_video1.png");
const leftPosterTwo = require("@/assets/img/left_video2.png");
const leftPosterThree = require("@/assets/img/left_video3.png");
const leftPosterFour = require("@/assets/img/left_video4.png");
const farmlandPoster = require("@/assets/img/right_video1.png");
const greenhousePoster = require("@/assets/img/right_video2.png");
const livestockPoster = require("@/assets/img/right_video3.png");
const ysIframePrefix = "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com";

const videoWall = [
  {
    title: "玫瑰大棚全景",
    src: leftGreenhouseLiveVideo,
    type: "m3u8",
    poster: leftPosterOne,
    iframeSrc: `${ysIframePrefix}/FC4283860/1.live&autoplay=1&accessToken=`,
    code: "FC4283860",
    cameras: ["CAM-01 在线"],
  },
  {
    title: "大田监测",
    src: leftFarmlandLiveVideo,
    type: "m3u8",
    poster: leftPosterTwo,
    iframeSrc: `${ysIframePrefix}/E53817475/1.live&autoplay=1&accessToken=`,
    code: "E53817475",
    cameras: ["CAM-01 在线"],
  },
  {
    title: "大田地块监控",
    src: leftCropLiveVideo,
    type: "m3u8",
    poster: leftPosterThree,
    iframeSrc: `${ysIframePrefix}/AZ8538489/1.live&autoplay=1&accessToken=`,
    code: "AZ8538489",
    cameras: ["CAM-01 在线"],
  },
  {
    title: "畜禽养殖基地",
    src: leftSweetPotatoLiveVideo,
    type: "m3u8",
    poster: leftPosterFour,
    iframeSrc: `${ysIframePrefix}/FB2502253/1.live&autoplay=1&accessToken=`,
    code: "FB2502253",
    cameras: ["CAM-01 在线"],
  },
];

const stats = [
  { label: "在线监控设备", value: 48, unit: "台" },
  { label: "离线故障摄像头", value: 2, unit: "台" },
  { label: "当日图像采集", value: 1260, unit: "张" },
  { label: "实时视频通道", value: 32, unit: "路" },
];

const onlineDeviceCount = stats[0].value;

const scenes = [
  {
    title: "大田农田",
    icon: "田",
    videoTitle: "大田农田",
    src: farmlandLiveVideo,
    type: "m3u8",
    poster: farmlandPoster,
    iframeSrc: `${ysIframePrefix}/D06502219/1.live&autoplay=1&accessToken=`,
    code: "D06502219",
    cameras: ["CAM-01 在线", "03号地块", "传感器18个"],
    metrics: [
      { icon: "墒", name: "土壤墒情", value: 48, unit: "%" },
      { icon: "温", name: "土壤温度", value: 24, unit: "℃" },
      { icon: "长", name: "长势等级", value: "优良", unit: "" },
      { icon: "湿", name: "空气湿度", value: 62, unit: "%" },
      { icon: "苗", name: "长势指数", value: 82, unit: "%" },
      { icon: "N", name: "在线传感器", value: 18, unit: "个" },
    ],
  },
  {
    title: "智慧温室",
    icon: "温",
    videoTitle: "智慧温室",
    src: greenhouseLiveVideo,
    type: "m3u8",
    poster: greenhousePoster,
    iframeSrc: `${ysIframePrefix}/FB2502104/1.live&autoplay=1&accessToken=`,
    code: "FB2502104",
    cameras: ["CAM-01 在线"],
    metrics: [
      { icon: "室", name: "室内温度", value: 28, unit: "℃" },
      { icon: "湿", name: "空气湿度", value: 71, unit: "%" },
      { icon: "C", name: "CO₂浓度", value: 460, unit: "ppm" },
      { icon: "光", name: "光照强度", value: 8600, unit: "lux" },
      { icon: "肥", name: "营养浓度", value: 420, unit: "ppm" },
      { icon: "帘", name: "卷帘状态", value: "已开启", unit: "" },
    ],
  },
  {
    title: "户外养鸭场",
    icon: "鸭",
    videoTitle: "户外养鸭场",
    src: livestockLiveVideo,
    type: "m3u8",
    poster: livestockPoster,
    iframeSrc: `${ysIframePrefix}/FB2502253/1.live&autoplay=1&accessToken=`,
    code: "FB2502253",
    cameras: ["CAM-01 在线", "户外水禽区"],
    metrics: [
      { icon: "温", name: "环境温度", value: 29, unit: "℃" },
      { icon: "湿", name: "空气湿度", value: 68, unit: "%" },
      { icon: "水", name: "水体温度", value: 26, unit: "℃" },
      { icon: "氧", name: "水体溶氧", value: 6.8, unit: "mg/L" },
      { icon: "鸭", name: "存栏数量", value: 1280, unit: "羽" },
      { icon: "警", name: "异常提醒", value: 0, unit: "条" },
    ],
  },
];
</script>

<style lang="less" scoped>
.realtime-monitor-layout {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
  align-items: stretch;
}
</style>
